import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
    field: {
        marginLeft: '15px',
    },
}))

export default function PromocodeListElement(props) {
    const classes = useStyles()

    return (
        <>
            <Typography component={'span'} variant={'body2'}>
                {props.title}
            </Typography>
            <Typography
                component={'span'}
                variant={'body2'}
                className={classes.field}
            >
                <b>{props.value || props.nullValueRepresent}</b>
            </Typography>
            <br/>
        </>
    )
}
